// src/hooks/useServicesState.js
import { useReducer, useCallback } from "react";
import { servicesReducer, initialState } from "../reducers/servicesReducer";
import { ACTIONS } from "../reducers/listActions";

// Custom hook to manage services state (including pagination and sorting)
export function useServicesState() {
  const [state, dispatch] = useReducer(servicesReducer, initialState);

  // Handler to change page
  const setPage = useCallback((newPage) => {
    dispatch({ type: ACTIONS.SET_PAGE, payload: newPage });
  }, []);

  // Handler to change rows per page
  const setRowsPerPage = useCallback((newRows) => {
    dispatch({ type: ACTIONS.SET_ROWS_PER_PAGE, payload: newRows });
  }, []);

  // Sorting handler – toggles order for the given property.
  // Since only date is sortable, this will usually be called with "date".
  const handleSortRequest = useCallback(
    (property) => {
      const isAsc = state.orderBy === property && state.order === "asc";
      const newOrder = isAsc ? "desc" : "asc";
      dispatch({ type: ACTIONS.SET_ORDER, payload: newOrder });
      dispatch({ type: ACTIONS.SET_ORDER_BY, payload: property });
      dispatch({ type: ACTIONS.SET_PAGE, payload: 0 }); // reset to first page
    },
    [state.order, state.orderBy]
  );

  return {
    state,             // Contains services, loading, error, order, orderBy, page, rowsPerPage, totalServices
    dispatch,          // For direct dispatching, if needed
    setPage,
    setRowsPerPage,
    handleSortRequest,
  };
}